/** @format */
import React, { useEffect, useState } from "react";
import ProfileInfo from "../../component/ProfileInfo";
import profile from "./profilePage.module.css";
import { useAuth } from "../../context/AuthContext";

const ProfilePage = () => {
  const [profileContent, setProfileContent] = useState();
  const { setBackButton } = useAuth();

  useEffect(() => {
    setBackButton(true);
    const getData = JSON.parse(sessionStorage.getItem("showProfile"));
    setProfileContent(getData);

    return () => {
      setBackButton(null);
    };
  }, []);

  return (
    <div className={profile.container}>
      <ProfileInfo {...profileContent} />
    </div>
  );
};

export default ProfilePage;
